<template>
  <div class="order-list-parts">
    <div class="title flex-between">
      <div>
        <el-input
          :placeholder="$lange == 'en' ? 'Order ID' : '订单号'"
          size="mini"
          v-model="partsTableParams.id"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <!-- <div>
        <el-input
          :placeholder="$lange == 'en' ? 'Care ID' : '请输入服务号'"
          size="mini"
          v-model="partsTableParams.workOrderId"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div> -->
      <div>
        <el-input
          :placeholder="$lange == 'en' ? 'Job ID' : 'Job ID'"
          size="mini"
          v-model="partsTableParams.jobId"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
        <div>
        <el-input
          :placeholder="$lange == 'en' ? 'FAS Code' : 'FAS料号'"
          size="mini"
          v-model="partsTableParams.fasCode"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div>
        <el-input
          :placeholder="$lange == 'en' ? 'Customer Name' : '公司'"
          size="mini"
          v-model="partsTableParams.customerName"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div>
        <el-select
          v-model="partsTableParams.handlerId"
          size="mini"
          :placeholder="this.$lange == 'en' ? 'Responsible' : '处理人'"
          clearable
        >
          <el-option
            v-for="(itmem, index) in user"
            :label="itmem.name"
            :value="itmem.id"
          ></el-option>
        </el-select>
      </div>
      <div>
        <el-select
          v-model="partsTableParams.status"
          size="mini"
          :placeholder="$lange == 'en' ? 'Status' : '状态'"
          clearable
        >
          <el-option
            v-for="(items, index) in status"
            v-if="index > 0"
            :label="$lange == 'en' ? items.label : items.label"
            :value="items.value"
          ></el-option>
          <!-- <el-option
            :label="$lange == 'en' ? 'New' : '备料中'"
            value="0"
          ></el-option>
          <el-option
            :label="$lange == 'en' ? 'Processing' : '部分配送'"
            value="1"
          ></el-option>
          <el-option
            :label="$lange == 'en' ? 'Completed' : '配送完成'"
            value="2"
          ></el-option> -->
        </el-select>
      </div>
      <div>
        <el-select
          v-model="partsTableParams.priority"
          size="mini"
          :placeholder="$lange == 'en' ? 'Priority' : '优先级'"
          clearable
        >
          <el-option
            :label="$lange == 'en' ? 'Low' : '低'"
            value="低"
          ></el-option>
          <el-option
            :label="$lange == 'en' ? 'Middle' : '中'"
            value="中"
          ></el-option>
          <el-option
            :label="$lange == 'en' ? 'High' : '高'"
            value="高"
          ></el-option>
        </el-select>
      </div>
      <div>
        <el-date-picker
          size="mini"
          v-model="seletcTime"
          type="datetimerange"
          range-separator="至"
          value-format="yyyy-MM-dd HH:mm:ss"
          :defaultTime="['00:00:00', '23:59:59']"
          :start-placeholder="$lange == 'en' ? 'StartTime' : '开始日期'"
          :end-placeholder="$lange == 'en' ? 'EndTime' : '结束日期'"
          @change="timeChange"
          style="width: 350px"
        >
        </el-date-picker>
      </div>
      <!-- <el-button type="primary" size="mini" @click="search">{{
        $lange == "en" ? "Search" : "搜索"
      }}</el-button> -->
      <el-button type="primary" size="mini" @click="exportData">{{
        $lange == "en" ? "Exporting search results" : "导出"
      }}</el-button>
    </div>
    <div class="content">
      <cc-table
        :config="partsTableConfig"
        :params="partsTableParams"
        :refesh-params="referTable"
      ></cc-table>
    </div>

    <el-dialog
      :visible.sync="detailsDialog"
      :fullscreen="true"
      :title="$lange == 'en' ? 'Details' : '详情'"
      @closed="dialogClose"
    >
      <template v-if="detailsDialog">
        <OrderPartsDescriptionV2
          :partsListIdV2="detailsId"
          :isDialog="true"
        ></OrderPartsDescriptionV2>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";

// import OrderPartsDescriptionView from "./OrderPartsDescription";
import OrderPartsDescriptionV2 from "./OrderPartsDescriptionV2";

export default {
  name: "OrderListParts",
  components: {
    OrderPartsDescriptionV2,
  },
  data() {
    return {
      status: [
        {
          label: "草稿",
          value: 0,
        },
        {
          label: this.$lange == "en" ? "New" : "新申请",
          value: 1,
        },
        {
          label: this.$lange == "en" ? "Customer Action" : "待客户确认",
          value: 2,
        },
        {
          label: this.$lange == "en" ? "Waiting Approval" : "待审批",
          value: 3,
        },
        {
          // label: this.$lange == "en" ? "Material Preparing" : "备料中",
          label: this.$lange == "en" ? "Material Preparing" : "未发货",
          value: 4,
        },
        {
          label: this.$lange == "en" ? "Partly deliveryed" : "部分发货",
          value: 5,
        },
        {
          label: this.$lange == "en" ? "Completed" : "已发货",
          value: 6,
        },
        {
          label: this.$lange == "en" ? "Close" : "已关闭",
          value: 7,
        },
        {
          label: this.$lange == "en" ? "Cancel" : "已取消",
          value: 8,
        },
      ],
      detailsDialog: false,
      detailsId: "",
      isHandleV2: false,
      partsTableParams: {
        workOrderId: "",
        priority: "",
        geCreateTime:"",
        leCreateTime:"",
        fasCode:""
      },
      partsTableParams2: {
        workOrderId: "",
        priority: "",
         geCreateTime:"",
        leCreateTime:"",
        fasCode:""
      },
      partsTableConfig: {
        api: "admin/fsb/parts/order/queryByParts",
        showPager: true,
        columns: [
          {
            prop: "partsOrderId",
            lable: this.$lange == "en" ? "Order No." : "订单号",
            minWidth: 150,
          },
          {
            prop: "partsOrder.status",
            lable: this.$lange == "en" ? "Status" : "订单状态",
            minWidth: this.$lange == "en" ? 140 : 110,
            // render: (e) => {
            //   return type[e.partsOrder.status].label;
            // },
            type: "tag",
            options: [
              {
                tagType: "info",
                text: "草稿",
              },
              {
                tagType: "info",
                text: this.$lange == "en" ? "New" : "新申请",
              },
              {
                tagType: "Blue",
                text: this.$lange == "en" ? "Customer Action" : "待客户确认",
              },
              {
                tagType: "info",
                text: this.$lange == "en" ? "Waiting Approval" : "待审批",
              },
              {
                tagType: "Blue",
                text: this.$lange == "en" ? "Material Preparing" : "备料中",
              },
              {
                tagType: "success",
                text: this.$lange == "en" ? "Partly deliveryed" : "部分发货",
              },
              {
                tagType: "success",
                text: this.$lange == "en" ? "Completed" : "已发货",
              },
              {
                tagType: "warning",
                text: this.$lange == "en" ? "Close" : "已关闭",
              },
              {
                tagType: "warning",
                text: this.$lange == "en" ? "Cancel" : "已取消",
              },
            ],
          },
          {
            prop: "jobId",
            lable: this.$lange == "en" ? "Job ID" : "Job ID",
            minWidth: 80,
          },
          {
            prop: "parts.fasCode",
            lable: this.$lange == "en" ? "FAS Code" : "FAS料号",
            minWidth: 80,
          },
          {
            prop: "parts.partsName",
            lable: this.$lange == "en" ? "Description" : "物料名称",
            minWidth: 110,
          },
          {
            prop: "partsNum",
            lable: this.$lange == "en" ? "Quantity" : "数量",
          },
          {
            prop: "feeType",
            lable: this.$lange == "en" ? "Cost Type" : "费用类型",
            minWidth: 80,
            type: "tag",
            options: [
              {
                tagType: "info",
                text: this.$lange == "en" ? "Free" : "保内",
              },
              {
                tagType: "warning",
                text: this.$lange == "en" ? "Paid" : "保外",
              },
            ],
          },
          {
            prop: "status",
            lable: this.$lange == "en" ? "Delivery" : "配送状态",
            minWidth: 100,
            type: "tag",
            options: [
              {
                tagType: "info",
                // text: this.$lange == "en" ? "New" : "备料中",
                text: this.$lange == "en" ? "New" : "未发货",
              },
              {
                tagType: "warning",
                // text: this.$lange == "en" ? "Processing" : "部分配送",
                text: this.$lange == "en" ? "Processing" : "部分发货",
              },
              {
                tagType: "success",
                text: this.$lange == "en" ? "Completed" : "已发货",
              },
            ],
          },
          {
            prop: "partsOrder.handlerName",
            lable: this.$lange == "en" ? "Responsible" : "处理人",
            minWidth: 100,
          },
          {
            prop: "planDeliverTime",
            lable: this.$lange == "en" ? "Plan to Ship" : "计划发货",
            minWidth: 100,
            render: (row) => {
              if (row.planDeliverTime) {
                return moment(row.planDeliverTime).format("YYYY-MM-DD");
              }
              return "";
            },
          },
          {
            prop: "relDeliverTime",
            lable: this.$lange == "en" ? "Ship on" : "实际发货",
            minWidth: 100,
            render: (row) => {
              if (row.relDeliverTime) {
                return moment(row.relDeliverTime).format("YYYY-MM-DD");
              }
              return "";
            },
          },
          {
            prop: "partsOrder.workOrder.customer.customerName",
            lable: this.$lange == "en" ? "Company" : "公司",
            minWidth: 150,
          },
          {
            prop: "partsOrder.adminName",
            lable: this.$lange == "en" ? "Request by" : "申请人",
            minWidth: 110,
          },
          {
            prop: "createTime",
            lable: this.$lange == "en" ? "Create at" : "创建时间",
            minWidth: 100,
            render: (row) => {
              return moment(row.createTime).format("YYYY-MM-DD");
            },
          },
        ],
        buttonsLabel: this.$lange == "en" ? "Processing" : "操作",
        buttons: [
          {
            name: this.$lange == "en" ? "View Details" : "详情",
            click: (row) => {
              // this.detailsDialog = true;
              // this.detailsId = row.partsOrder.id;
              // this.isHandleV2 = row.partsOrder.isHandle;
              this.newWindow({
                url: "/admin/order/list/parts/des?id=" + row.partsOrder.id,
                name: "配件订单详情",
              });
            },
          },
          {
            name: this.$lange == "en" ? "Handle" : "处理",
            check: (row) => {
              return row.partsOrder.isHandle;
            },
            click: (row) => {
              this.newWindow({
                url: "/admin/order/list/parts/des?id=" + row.partsOrder.id,
                name: "配件订单详情",
              });
              // this.detailsDialog = true;
              // this.detailsId = row.partsOrder.id;
              // this.isHandleV2 = row.partsOrder.isHandle;
            },
          },
        ],
      },
      user: [],
      referTable: -1,
      seletcTime: [],
    };
  },
  methods: {
    timeChange(e) {
      if (e) {
        this.partsTableParams.geCreateTime = e[0];
        this.partsTableParams.leCreateTime = e[1];
      } else {
        this.partsTableParams.geCreateTime = "";
        this.partsTableParams.leCreateTime = "";
      }
    },
    dialogClose() {
      if (this.isHandleV2) {
        this.referTable = new Date().getTime();
      }
    },
    search() {
      this.partsTableParams2 = { ...this.partsTableParams };
    },
    exportData() {
      // let text = "?appId=fosber";
      // for (const key in this.partsTableParams2) {
      //   if(this.partsTableParams2[key]!=='' &&this.partsTableParams2[key]!==undefined ){
      //     text += "&" + key + "=" + this.partsTableParams2[key];
      //   }
      // }
      let text = "?appId=fosber";
      for (const key in this.partsTableParams) {
        if (
          this.partsTableParams[key] !== "" &&
          this.partsTableParams[key] !== undefined
        ) {
          text += "&" + key + "=" + this.partsTableParams[key];
        }
      }
      window.open("/admin/fsb/parts/order/partsOrderExport" + text);
    },
  },
  mounted() {
    // this.ccRequest
    //   .do("admin/fsb/user/query", { pageSize: 2000 }, "GET")
    //   .then((res) => {
    //     this.user = res;
    //   });
    let api = `admin/fsb/work/order/queryHandlerUser?pageSize=999&isAsc=true`;
    this.ccRequest
      .do(
        api,
        ["accessoriesSpecialist", "projectManager", "afterSalesManager"],
        "POSTJSON"
      )
      .then((res) => {
        this.user = res;
      });
  },
};
</script>
<style >
.order-list-parts .el-dialog__body {
  padding: 10px 20px 30px 20px;
}
</style>
<style scoped lang="scss">
.order-list-parts {
  .title {
    padding: 20px;
    background: #ffffff;
    margin-bottom: 5px;
    justify-content: flex-start;
    > * {
      margin-right: 20px;
    }
  }
}
</style>
